export default "__VITE_ASSET__Ch1U3_M5__"